import { render, staticRenderFns } from "./ViAttendance.vue?vue&type=template&id=5516ff32&scoped=true"
import script from "./ViAttendance.vue?vue&type=script&lang=js"
export * from "./ViAttendance.vue?vue&type=script&lang=js"
import style0 from "./ViAttendance.vue?vue&type=style&index=0&id=5516ff32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516ff32",
  null
  
)

export default component.exports